import * as React from "react";
import { inject, observer } from "mobx-react";
import { AdvertisingStore, initializeClear, Targeting, TargetingEvent } from "bernie-plugin-ads-loader-script";

interface AdScriptsProps {
  advertising?: AdvertisingStore;
}

export const AdScripts: React.FunctionComponent<AdScriptsProps> = inject("advertising")(
  observer((props: AdScriptsProps) => {
    const { advertising } = props;

    const updateTargeting = () => {
      if (window) {
        const targetingData: Targeting = {};
        if (advertising?.CMPTST) {
          targetingData.CMPTST = advertising.CMPTST;
        }
        const targetingEvent: TargetingEvent = { type: "update", targeting: targetingData };
        window.meso = window.meso || {};
        window.meso.targeting = window.meso.targeting || [];
        // ignore below is a temporary fix needed to allow TypeScript to ignore weak types
        // @ts-ignore
        window.meso.targeting.push(targetingEvent);
      }
    };

    const updateChanges = () => {
      if (window && advertising?.includeAdLoader) {
        updateTargeting();
      }
    };

    // componentDidMount and cleanup
    React.useEffect(() => {
      updateChanges();
      return initializeClear();
    }, []);

    // componentDidUpdate - update when includeAdLoader = true
    React.useEffect(() => {
      updateChanges();
    }, [advertising?.includeAdLoader]);

    return null;
  })
);
